import axios from 'axios';
import { API_BASE_URL } from '../config';

// 获取认证头
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

// 获取学生个人信息
export const getStudentProfile = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/student/profile`,
      getAuthHeaders()
    );
    
    // 确保返回的数据包含所需的字段
    const data = response.data.data || {};
    return {
      ...data,
      stats: {
        total_assignments: data.stats?.total_assignments || 0,
        completed_exercises: data.stats?.completed_exercises || 0,
        in_progress_exercises: data.stats?.in_progress_exercises || 0,
        pending_exercises: data.stats?.pending_exercises || 0,
        overdue_exercises: data.stats?.overdue_exercises || 0,
        average_score: data.stats?.average_score || 0
      },
      recentSubmissions: data.recentSubmissions || []
    };
  } catch (error) {
    console.error('获取学生个人信息失败:', error);
    throw error;
  }
};

// 更新学生个人信息
export const updateStudentProfile = async (profileData) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/student/profile`,
      profileData,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('更新学生个人信息失败:', error);
    throw error;
  }
};

// 更改学生密码
export const changeStudentPassword = async (passwordData) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/student/change-password`,
      passwordData,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('更改密码失败:', error);
    throw error;
  }
}; 